import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import OrderProp from '../../../shop/propTypes/orderProp';
import DetailItem from '../../../shop/detail/DetailItem';
import { formatDate } from '../../../../services/dateUtilityFunctions';

function MainSection(props) {
  const { t, opportunity } = props;

  const { name, number, createdAt } = opportunity;
  const date = formatDate(createdAt, 'MMM DD, YYYY');

  return (
    <div className="main-section">
      <DetailItem
        header={t('opportunity.name')}
        text={name}
        textClass="highlight"
        wrapperClass="opportunity-name"
      />
      <DetailItem
        header={t('opportunity.number')}
        text={number}
        textClass="highlight"
        wrapperClass="opportunity-number"
      />
      <DetailItem
        header={t('date')}
        text={date}
        wrapperClass="opportunity-date"
      />
    </div>
  );
}

MainSection.propTypes = {
  t: PropTypes.func.isRequired,
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
};

export default translate(MainSection);
